namespace Matrix.Administration {
    export interface UserLogRow {
        Username?: string;
        LogDate?: string;
        LogTypeCode?: string;
        ClientAddress?: string;
        UserAgent?: string;
        Details?: string;
        Path?: string;
        RowId?: number;
        Hash?: number;
        Counter?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace UserLogRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'Username';
        export const localTextPrefix = 'Administration.UserLog';
        export const deletePermission = 'NoPermission';
        export const insertPermission = 'NoPermission';
        export const readPermission = 'Administration:Security';
        export const updatePermission = 'NoPermission';

        export declare const enum Fields {
            Username = "Username",
            LogDate = "LogDate",
            LogTypeCode = "LogTypeCode",
            ClientAddress = "ClientAddress",
            UserAgent = "UserAgent",
            Details = "Details",
            Path = "Path",
            RowId = "RowId",
            Hash = "Hash",
            Counter = "Counter",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
